import {Amplify} from 'aws-amplify';

import {stage} from '../config/stage';

// get config
import {ConsoleLogger} from 'aws-amplify/utils';
import {config} from "../config/amplify";

Amplify.configure(config)

stage === 'ide'
    ? (ConsoleLogger.LOG_LEVEL = 'DEBUG')
    : (ConsoleLogger.LOG_LEVEL = 'INFO');

// FNP-960: only read for handles attached to the global; an index signature
// of `unknown` keeps the rest of the DOM Window typing intact.
declare let window: Window & { [key: string]: unknown };

window.LOG_LEVEL = 'DEBUG';

const currentConfig = Amplify.getConfig();
console.debug('currentConfig', currentConfig);

